import { createSelector } from '@reduxjs/toolkit'

import { identity } from '../helpers/fp'

const getTaxOfficeSlice = (state) => state.taxOffice
export const getTaxOfficeFiscalAddress = (state) => {
    const { requestStatus, ...fiscalAddress } = getTaxOfficeSlice(state).fiscalAddress
    return fiscalAddress
}
export const getTaxOfficeFiscalAddressRequestStatus = (state) => getTaxOfficeSlice(state).fiscalAddress.requestStatus
export const getTaxOfficeReferenceNumber = (state) => getTaxOfficeSlice(state).referenceNumber

export default createSelector([getTaxOfficeSlice], identity)
